import {
  actionDownLoadUrlWithUtM,
  actionSignInUrlWithUtM,
} from "lib/constants";
import * as React from "react";

export const TopHeaderNavigation: React.FC = () => {
  return (
    <nav
      id="site-navigation"
      className="navbar navbar-expand-sm main-nav"
      aria-label="Main"
    >
      <ul id="menu-primary-menu" className="navbar-nav me-auto">
        <li
          id="menu-item-13256"
          className="menu-item menu-item-type-custom menu-item-object-custom menu-item-13256 nav-item"
        >
          <a href="https://bumble.shop/" className="nav-link">
            The Shop
          </a>
        </li>
        <li
          id="menu-item-13337"
          className="app-link menu-item menu-item-type-custom menu-item-object-custom menu-item-13337 nav-item"
        >
          <a
            target="_blank"
            href="https://bumble.com/get-started?pid=bumble-new-buzz"
            className="nav-link"
          >
            The App
          </a>
        </li>
        <li
          id="menu-item-13257"
          className="menu-item menu-item-type-custom menu-item-object-custom menu-item-13257 nav-item"
        >
          <a
            href="https://bumble.com/bumble-honey-ambassadors"
            className="nav-link"
          >
            Ambassadors
          </a>
        </li>
        <li
          id="menu-item-13338"
          className="menu-item menu-item-type-custom menu-item-object-custom menu-item-13338 nav-item"
        >
          <a href="https://bumble.events/" className="nav-link">
            Events
          </a>
        </li>
        <li
          id="menu-item-13255"
          className="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-2 current_page_item menu-item-13255 nav-item active"
        >
          <a href="/the-buzz" className="nav-link active" aria-current="page">
            The Buzz
          </a>
        </li>
        <li
          id="menu-item-13254"
          className="menu-item menu-item-type-custom menu-item-object-custom menu-item-13254 nav-item"
        >
          <a href="https://bumble.com/about" className="nav-link">
            About
          </a>
        </li>
        <li
          id="menu-item-13259"
          className="menu-item menu-item-type-custom menu-item-object-custom menu-item-13259 nav-item menu-item--btn menu-item--btn-cta"
        >
          <a
            className="btn btn-outline-primary"
            href={actionDownLoadUrlWithUtM}
          >
            Download the App
          </a>
        </li>
        <li
          id="menu-item-13258"
          className="menu-item menu-item-type-custom menu-item-object-custom menu-item-13258 nav-item menu-item--btn-cta"
        >
          <a className="btn btn-outline-primary" href={actionSignInUrlWithUtM}>
            Sign In
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default TopHeaderNavigation;
